import axios from '@/utils/request'
var Qs = require('qs')
export default {
	// 2021-08-06
	create(params) {
		return axios.post('/order-bill', params)
	},
	// 2021-08-07
	allYear() {
		return axios.get('/order-bill/all-year')
	},
	// 2021-08-09
	trendChart(params) {
		return axios.get('/order-bill/trend-chart', params)
	},
	// 2021-08-07
	findByYear(params) {
		return axios.get('/order-bill/find-by-year', params)
	},
	// 2021-08-07
	delete(id) {
		return axios.delete('/order-bill/' + id)
	},

}

